export enum BmarkSummaryRiskFilterType {
  /**
   * BmarkSummaryRiskFilterType.All is the same as having no view filter.
   **/
  ALL,
  WARNING,
  ALERT,
}
